import { Component, Injectable, OnInit } from '@angular/core';
import { HttpService } from 'src/app/https.service';
import { URLUtils } from 'src/app/urlUtils';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { LeadsService } from 'src/app/service/lead.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { LeadDetailsModalComponent } from 'src/app/modal/lead-details-modal/lead-details-modal.component';
import { ConfirmationComponent } from 'src/app/modal/confirmation/confirmation.component';
import { ViewDocumentModalComponent } from 'src/app/modal/view-document-modal/view-document-modal.component';
import { AttachMatterComponent } from '../attach-matter/attach-matter.component';

@Component({
  selector: 'app-view-document',
  templateUrl: './view-document.component.html',
  styleUrls: ['./view-document.component.css']
})
export class ViewDocumentComponent {


  constructor(private leadsService: LeadsService, private route: ActivatedRoute, private modalService: NgbModal,
    public sanitizer: DomSanitizer, private httpService: HttpService, private spinner: NgxSpinnerService, private toast: ToastrService) { }

  queries: any[] = [];
  filteredQueries: any[] = [];
  searchTerm: string = '';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  departmentsMap: { [key: string]: string } = {};
  leadNotes: Map<string, string> = new Map();
  pdfSrc: any;
  newdoc:any[]=[];
  ngOnInit() {
    // Get docs with id params
    this.route.paramMap.subscribe(params => {
      const enquiryId = params.get('id');
      if (enquiryId) {
        this.getDocumentList(enquiryId);
      }
    });
  }

  getDocumentList(enquiryId: any) {
    this.httpService.sendGetRequest(URLUtils.getDocuments(enquiryId)).subscribe((res: any) => {
      this.queries = res.docs;
      this.filteredQueries = this.queries;
      //console.log('queries',this.queries);
    });
  }

  search() {
    if (!this.searchTerm.trim()) {
      this.filteredQueries = this.queries;
      return;
    }

    const term = this.searchTerm.toLowerCase();
    this.filteredQueries = this.queries.filter(query =>
      query.name.toLowerCase().includes(term) ||
      query.email.toLowerCase().includes(term) ||
      query.department.toLowerCase().includes(term)
    );
  }

  viewDocument(lead: any) {
    const modalRef = this.modalService.open(ViewDocumentModalComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.lead = { ...lead };
  }

  downloadDocument(doc: any) {
    this.httpService.sendGetRequest(URLUtils.downloadDocument(doc.id)).subscribe((res: any) => {
      if (res.error == false) {
        this.spinner.show();
        window.open(res?.data?.url, "_blank");
        this.toast.success('Document downloaded successfully')
        this.spinner.hide()
      }
    });
  }

    attachMatter(lead: any) {
      const modalRef = this.modalService.open(AttachMatterComponent, {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
    
      modalRef.componentInstance.lead = { ...lead };
      this.leadsService.setLead(lead); //pass doc data

      // Handle the result when the modal is closed
      modalRef.result.then((selectedMatterIds) => {
        if (selectedMatterIds && Array.isArray(selectedMatterIds)) {
          //console.log('Selected matter IDs:', selectedMatterIds);
          // You can perform additional actions with the selected matter IDs if needed
        }
      }).catch((reason) => {
        //console.log('Modal dismissed:', reason);
      });
    }

  getPaginatedqueries() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.filteredQueries.slice(startIndex, endIndex);
  }

  getTotalPages() {
    return Math.ceil(this.filteredQueries.length / this.itemsPerPage);
  }

  getPageNumbers() {
    const totalPages = this.getTotalPages();
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.getTotalPages()) {
      this.currentPage = page;
    }
  }

  getPaginationRange() {
    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(start + this.itemsPerPage - 1, this.filteredQueries.length);
    return `${start}-${end} of ${this.filteredQueries.length} items`;
  }
}